import React from "react";
import { Footer } from "antd/lib/layout/layout";
import { Typography } from "antd";
import { CopyrightOutlined, TrademarkOutlined } from "@ant-design/icons";
import packageJson from "../../../package.json";

import "./index.css";

export default function Footers() {
  return (
    <Footer className="ftr">
      <CopyrightOutlined />
      <Typography.Text
        style={{ marginBottom: 2, marginLeft: 6, marginRight: 6 }}
      >
        Copyright for Rapsap 2025 | Version: {packageJson.version}
      </Typography.Text>
      {/* <TrademarkOutlined /> */}
    </Footer>
  );
}
